module.exports = __webpack_public_path__ + "static/media/module-bibliotheek.5cb2fc82.svg";